import React from "react";

const ConfirmModal = ({
  open,
  title = "Confirm",
  message,
  onYes,
  onNo,
}) => {
  if (!open) return null;

  return (
    <div className="modal-backdrop-custom d-flex align-items-center justify-content-center">
      <div className="bg-white rounded p-4 text-center" style={{ width: "22rem" }}>
        <h5 className="font-weight-bold mb-2">{title}</h5>

        <p className="text-muted mb-4">
          {message}
        </p>

        <div className="d-flex justify-content-center">
          <button
            className="btn btn-success mr-2 px-4"
            onClick={onYes}
          >
            Yes
          </button>

          <button
            className="btn btn-info px-4"
            onClick={onNo}
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
